<div [id]="idModal" class="modal fade modal-filter" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Pesquisar Mercado
                </h4>
            </div>
            <div class="modal-body" #modalBody>
                <div class="row">
                    <div class="col-12">
                        <table class="table table-striped table-hover datatables" [id]="idDataTable">
                            <thead>
                                <tr>
                                    <th class="col-codigo text-right">Código</th>
                                    <th class="col-codigo-integracao-erp text-right">Código ERP</th>
                                    <th class="col-nome">Nome</th>
                                    <th class="col-situacao text-center">Situação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let entity of entities" (click)="onSelectEntity(entity)">
                                    <td class="col-codigo text-right">{{entity.codigo}}</td>
                                    <td class="col-codigo-integracao-erp text-right">{{entity.codigoIntegracaoErp}}</td>
                                    <td class="col-nome">{{entity.nome}}</td>
                                    <td class="col-situacao text-center">
                                        <sgt-mercado-situacao-badge
                                            [situacao]="entity.situacao">
                                        </sgt-mercado-situacao-badge>
                                    </td> 
                                </tr>
                            </tbody>
                        </table>                    
                    </div>
                </div>                
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>